import type { CategoryNavConfig } from '@/lib/sections/types';
import { collectionUrl } from '@/lib/collectionUrl';
import urodziny from '@assets/home_category_tiles/urodzinowe.webp';
import dlaNiej from '@assets/home_category_tiles/dla_niej.webp';
import roze from '@assets/home_category_tiles/róże.webp';
import flowerboxy from '@assets/home_category_tiles/flowerboxy.webp';
import pogrzeb from '@assets/home_category_tiles/kompozycje_pogrzebowe.webp';
import doniczkowe from '@assets/home_category_tiles/rośliny_doniczkowe.webp';
import balony from '@assets/home_category_tiles/balony_z_helem.webp';
import slubne from '@assets/home_category_tiles/bukiet_slubny.webp';

export const CATEGORY_NAV_CONFIG: CategoryNavConfig = {
  categories: [
    { title: 'Urodziny', subtitle: '', href: collectionUrl('urodziny'), image: urodziny, icon: 'urodziny', handle: 'urodziny' },
    { title: 'Dla Niej', subtitle: '', href: collectionUrl('dla-dziewczyny'), image: dlaNiej, icon: 'ukochana', handle: 'dla-dziewczyny' },
    { title: 'Róże', subtitle: '', href: collectionUrl('roze'), image: roze, icon: 'roze', handle: 'roze' },
    { title: 'Flowerboxy', subtitle: '', href: collectionUrl('flower-boxy'), image: flowerboxy, icon: 'flowerBox', handle: 'flower-boxy' },
    { title: 'Pogrzeb', subtitle: '', href: collectionUrl('pogrzeb'), image: pogrzeb, icon: 'pogrzeb', handle: 'pogrzeb' },
    { title: 'Rośliny doniczkowe', subtitle: '', href: collectionUrl('kwiaty-doniczkowe'), image: doniczkowe, icon: 'rosliny', handle: 'kwiaty-doniczkowe' },
    { title: 'Balony z helem', subtitle: '', href: collectionUrl('balony-z-helem'), image: balony, icon: 'balony', handle: 'balony-z-helem' },
    { title: 'Bukiety ślubne', subtitle: '', href: collectionUrl('slub'), image: slubne, icon: 'slub', handle: 'slub' },
  ],
};
